module.exports = __webpack_public_path__ + "media/images/resource/Vector-4c98e3012e4c30e665f076833f3569fc.png";